export const PAGINATION_ELLIPSIS_START = 'ellipsis-start' as const;
export const PAGINATION_ELLIPSIS_END = 'ellipsis-end' as const;

export type PaginationItem = number
  | typeof PAGINATION_ELLIPSIS_START
  | typeof PAGINATION_ELLIPSIS_END;

const pageRange = (start: number, end: number): number[] => (
  Array.from({ length: end - start + 1 }, (_, index) => start + index)
);

export const getPaginationItems = (
  currentPage: number,
  totalPages: number,
  compact = false,
): PaginationItem[] => {
  if (totalPages < 1) {
    return [];
  }

  const current = Math.min(Math.max(currentPage, 1), totalPages);

  if (totalPages <= (compact ? 5 : 7)) {
    return pageRange(1, totalPages);
  }

  if (compact) {
    if (current <= 2) {
      return [1, 2, 3, 4, PAGINATION_ELLIPSIS_END, totalPages];
    }

    if (current === 3) {
      return [1, 2, 3, 4, PAGINATION_ELLIPSIS_END, totalPages];
    }

    if (current >= totalPages - 2) {
      return [1, PAGINATION_ELLIPSIS_START, ...pageRange(totalPages - 3, totalPages)];
    }

    return [
      1,
      PAGINATION_ELLIPSIS_START,
      current,
      current + 1,
      PAGINATION_ELLIPSIS_END,
      totalPages,
    ];
  }

  if (current <= 4) {
    return [...pageRange(1, 5), PAGINATION_ELLIPSIS_END, totalPages];
  }

  if (current >= totalPages - 3) {
    return [1, PAGINATION_ELLIPSIS_START, ...pageRange(totalPages - 4, totalPages)];
  }

  return [
    1,
    PAGINATION_ELLIPSIS_START,
    current - 1,
    current,
    current + 1,
    PAGINATION_ELLIPSIS_END,
    totalPages,
  ];
};
